import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import type { LyDoTangGiamCCDC } from '@/types/schemas';

interface ActionBarProps {
  selectedObj?: LyDoTangGiamCCDC | null;
  onAddIconClick: () => void;
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  onCopyIconClick: () => void;
  onWatchIconClick: () => void;
  onRefreshClick?: () => void;
  onExportClick?: () => void;
  onFixedColumnsClick?: () => void;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  selectedObj,
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onRefreshClick,
  onExportClick,
  onFixedColumnsClick
}) => {
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Lý do tăng giảm CCDC</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} disabled={!selectedObj} />
      <ActionButtonV2
        icon={Trash3Stroke}
        title='Xóa'
        onClick={onDeleteIconClick}
        disabled={!selectedObj}
        variant='destructive'
      />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyIconClick} disabled={!selectedObj} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} disabled={!selectedObj} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick || (() => {}),
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: onFixedColumnsClick || (() => {}),
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: onExportClick || (() => {}),
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};
